if(document.body.classList.contains("template-customers")){
  let arrIcons = ["//cdn.shopify.com/s/files/1/0559/4280/7726/t/28/assets/account-icon.svg?v=3161418157376324486", "//cdn.shopify.com/s/files/1/0559/4280/7726/t/28/assets/address-icon.svg?v=11310307846020916436", "//cdn.shopify.com/s/files/1/0559/4280/7726/t/28/assets/order-icon.svg?v=10996596837926781126"];
  var x, i, j, l, ll, selElmnt, a, b, c;
  x = document.getElementsByClassName('custom-select');
  l = x.length;
  for (i = 0; i < l; i++) {
    selElmnt = x[i].getElementsByTagName('select')[0];
    let firstElem = selElmnt.firstElementChild;
    let arrDataAttr = [];
    while (firstElem) {
      if (firstElem.getAttribute('value')) {
        arrDataAttr.push(firstElem.getAttribute('value'));
        firstElem = firstElem.nextElementSibling;
      } else {
        arrDataAttr.push(firstElem.dataset.tag);
        firstElem = firstElem.nextElementSibling;
      }
    }
    let attr = x[i].classList[1];
    let innHTML;
    if (document.body.classList.contains('template-collection')) {
      if (attr.indexOf('-') && !attr.includes('sort-select')) {
        innHTML = attr.substr(attr.indexOf('-') + 1);
      } else if (!attr.indexOf('-') && !attr.includes('sort-select')) {
        innHTML = attr;
      } else {
        innHTML = 'Sort by';
      }
    }
    if (document.body.classList.contains('template-product')) {
      innHTML = 'Variant';
    }

    ll = selElmnt.length;
    a = document.createElement('DIV');
    a.setAttribute('class', 'select-selected');
    // a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
    a.innerHTML = innHTML;
    x[i].appendChild(a);
    b = document.createElement('DIV');
    b.setAttribute('class', 'select-items select-hide');

    for (j = 0; j < ll; j++) {
      let inputRadio = document.createElement('input');
      inputRadio.setAttribute('class', 'custom-radio');
      inputRadio.setAttribute('type', 'radio');
      inputRadio.setAttribute('name', attr);
      let label = document.createElement('label');
      label.setAttribute('class', 'label-text');
      c = document.createElement('DIV');
      c.setAttribute('class', 'select__item');
      c.setAttribute('data-handle', arrDataAttr[j]);
      label.innerHTML = selElmnt.options[j].innerText + `<span class="span-image"><img loading="lazy"  src="${arrIcons[j]}" /></span>`;

      c.appendChild(inputRadio);
      c.appendChild(label);
      c.addEventListener('click', function (e) {
        var y, i, k, s, h, sl, yl;
        let element = this.firstElementChild.nextElementSibling.innerHTML;
        s = this.parentNode.parentNode.getElementsByTagName('select')[0];
        sl = s.length;
        h = this.parentNode.previousSibling;
        for (i = 0; i < sl; i++) {

          if (s.options[i].innerHTML.replace('-', ' ') == element.split("<")[0] ) {
            s.selectedIndex = i;
            y = this.parentNode.getElementsByClassName('same-as-selected');
            yl = y.length;
            for (k = 0; k < yl; k++) {
              y[k].classList.remove('same-as-selected');
            }
            this.setAttribute('class', 'select__item same-as-selected');
            break;
          }
        }
        h.click();
      });
      b.appendChild(c);
    }
    x[i].appendChild(b);
    a.addEventListener('click', function (e) {
      e.stopPropagation();
      closeAllSelect(this);
      this.nextSibling.classList.toggle('select-hide');
      this.classList.toggle('select-arrow-active');
    });
  }

  function closeAllSelect(elmnt) {
    var x,
      y,
      i,
      xl,
      yl,
      arrNo = [];
    x = document.getElementsByClassName('select-items');
    y = document.getElementsByClassName('select-selected');
    xl = x.length;
    yl = y.length;
    for (i = 0; i < yl; i++) {
      if (elmnt == y[i]) {
        arrNo.push(i);
      } else {
        y[i].classList.remove('select-arrow-active');
      }
    }
    for (i = 0; i < xl; i++) {
      if (arrNo.indexOf(i)) {
        x[i].classList.add('select-hide');
      }
    }
  }

  document.addEventListener('click', closeAllSelect);
}
